import styled from "styled-components";

import GreenMau from "../../../assets/sprites/elements/maureske_green_body.gif";
import GreenMauLeft from "../../../assets/sprites/elements/maureske_green_left.gif";
import GreenMauRight from "../../../assets/sprites/elements/maureske_green_right.gif";
import BlueMau from "../../../assets/sprites/elements/maureske_blue_body.gif";
import BlueMauLeft from "../../../assets/sprites/elements/maureske_blue_left.gif";
import BlueMauRight from "../../../assets/sprites/elements/maureske_blue_right.gif";
import RedMau from "../../../assets/sprites/elements/maureske_red_body.gif";
import RedMauLeft from "../../../assets/sprites/elements/maureske_red_left.gif";
import RedMauRight from "../../../assets/sprites/elements/maureske_red_right.gif";

export const Title = styled.div`
  background: green;
  width: 96%;
  max-width: 100%;
  height: 31px;
  padding: 0 20px;
  color: white;
  background-image: url(${GreenMauLeft}), url(${GreenMauRight}),
    url(${GreenMau});
  background-size: 10px 31px, 16px 31px, 83px 31px;
  background-repeat: no-repeat, no-repeat, repeat-x;
  background-position: left top, right top, left top;
  margin-bottom: 1.5rem;
`;

export const BlueTitle = styled(Title)`
  background-image: url(${BlueMauLeft}), url(${BlueMauRight}), url(${BlueMau});
`;

export const RedTitle = styled(Title)`
  background-image: url(${RedMauLeft}), url(${RedMauRight}), url(${RedMau});
`;

export const Date = styled.span`
  font-size: 0.8rem;
`;

export const TitleContent = styled.span`
  font-size: 0.95rem;
  font-weight: bold;
`;
